module.exports = __webpack_public_path__ + "img/logo.68852ff1.png";